import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import { loadFacebookPixel, noscriptPixel } from "./pixel";
import { buildAdvancedMatching, sendEventToServer } from "./utils";
import PrivacyPolicy from "./privacyPolicy";

function App() {
  useEffect(() => {
    loadFacebookPixel();
  }, []);

  const handleApplyNowClick = () => {
    if (window.fbq) {
      window.fbq("track", "Lead", {
        content_name: "Start Full Application",
        content_category: "Application",
      });
    }

    const advancedMatching = buildAdvancedMatching();

    const customDataPayload = {
      content_name: "Start Full Application",
      content_category: "Application",
    };

    sendEventToServer(advancedMatching, "Lead", customDataPayload);
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <div className="App">
            <section className="landing">
              <div className="grid-container">
                <div className="text-block">
                  {/* <h1>
                    You're next in line on your recruiter's call schedule!
                  </h1> */}
                  <h1>
                    You're One Step Closer to Joining the
                    <a
                      href="https://itpwexp.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/logo192.png" // Update the path to where your logo is stored
                        alt="ITP Logo"
                        style={{
                          verticalAlign: "middle",
                          marginLeft: "10px",
                          marginRight: "10px",
                          height: "1.8em",
                        }}
                      />
                    </a>
                    Team!
                  </h1>
                  {/* <p>
                    The last step is to fill out our Full Driver Application.
                    Our team can only process your application once it’s
                    completed. Don’t put it off, you’ll thank yourself later.
                  </p> */}
                  <p>
                    You're next in line on your recruiter's call schedule!
                    {"\n"}
                    See what we offer at your own pace. Your recruiter will
                    reach out in the mean time to answer all your questions!
                  </p>
                  <a
                    // href="https://intelliapp.driverapponline.com/c/itpwestern?uri_b=ia_itpwestern_904180673"
                    href="https://itpwexp.com/our-offerings"
                    onClick={handleApplyNowClick}
                    className="apply-button"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Explore What We Offer
                  </a>
                  <p
                    style={{
                      fontSize: "0.8em",
                      fontStyle: "italic",
                      marginTop: "6px",
                    }}
                  >
                    No commitment if you click!
                  </p>
                </div>
                <div className="video-container">
                  <video className="video" controls autoPlay muted loop>
                    <source src="/peter2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              <div className="footer">
                <div className="copyright">
                  Copyright ©2024 All Rights Reserved
                </div>
                <div className="contact">
                  {/* Contact: {"\n"} */}
                  <a href="mailto:support@apply-itpwexp.com">
                    support@apply-itpwexp.com
                  </a>
                  <div>
                    <a
                      href="https://itpwexp.com/our-privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                  </div>
                </div>
              </div>
            </section>
            {noscriptPixel()}
          </div>
        }
      />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  );
}

export default App;
